import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';


export class ChildCountClass extends React.Component {
	// Need to have this as a separate component so it can receive updates
	numChildrenChecked = ids => {
		const { selectedList: { distList } } = this.props;
		const matchingIds = ids.filter(x => distList.indexOf(x) > - 1);

		return matchingIds.length;
	}

	render() {
		const { descendantAccountIds, i18n } = this.props;

		return (
			<span className='child-count'>
				{i18n.t('X_OF_Y_SELECTED', {
					selected: this.numChildrenChecked(descendantAccountIds),
					total: descendantAccountIds.length,
				})}
			</span>
		);
	}
}

ChildCountClass.propTypes = {
	allLists: PropTypes.array.isRequired,
	descendantAccountIds: PropTypes.array.isRequired,
	selectedList: PropTypes.shape({}).isRequired,
	i18n: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
	allLists: state.allLists || [],
	selectedList: state.selectedList,
});

const ChildCount = connect( mapStateToProps,null)(ChildCountClass);

export default withTranslation()(ChildCount);
